var exports = {
  "qf": "placeholder-aE5rY",
  "Sl": "image-aE5rY",
  "U6": "pulse-aE5rY",
  "n8": "line-aE5rY",
};

module.exports = exports;
